import script from "./StyleInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./StyleInputs.vue?vue&type=script&setup=true&lang=ts"

import "./StyleInputs.vue?vue&type=style&index=0&id=363f90c0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363f90c0"]])

export default __exports__